import { type Ref } from "vue";
import { useComplexModelModelWithChanges } from "@/features/core-shared/composables/useComplexModelWithChanges";
import { useGeoCitiesMasterdata } from "@/features/masterdata/composables/useGeoCitiesMasterdata";
import type { City as GeoCity } from "@/types/generated/GeoMasterDataApi";

/**
 * Factory for the additional cities field.
 *
 * @param cityCodes - reactive ref of city code array from the data source
 */
export function useAdditionalCitiesField(cityCodes: Ref<string[]>) {
  const { geoCities } = useGeoCitiesMasterdata();

  const initialValue = computed<GeoCity[]>(() => {
    if (!cityCodes.value?.length) return [];
    return cityCodes.value
      .map((code) => geoCities.value.find((c) => c.code === code))
      .filter((c): c is GeoCity => c !== undefined);
  });

  const { model, hasChanges, isFilled, reset } = useComplexModelModelWithChanges<GeoCity[]>(initialValue);

  return {
    id: "location.additional-cities" as const,
    model,
    cities: geoCities,
    hasChanges,
    isFilled,
    reset,
  };
}
